(function () {
  'use strict';

  // ── Helpers ──────────────────────────────────────────────────────────────

  function setLoading(btn, isLoading) {
    var label = btn.querySelector('.ccu-item__btn-label');
    var spinner = btn.querySelector('.ccu-item__spinner');
    if (!label || !spinner) return;
    btn.disabled = isLoading;
    btn.dataset.ccuLoading = isLoading ? '1' : '';
    label.style.display = isLoading ? 'none' : '';
    spinner.style.display = isLoading ? 'flex' : 'none';
  }

  function formatMoney(cents) {
    if (!cents || cents === '0') return '';
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, '{{amount}} ₪');
      }
    } catch (e) { /* ignore */ }
    return '₪' + (parseInt(cents, 10) / 100).toFixed(0);
  }

  function swapCartDrawer(sectionsPayload) {
    var html = sectionsPayload['cart-drawer'];
    if (!html) return false;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newEl = doc.querySelector('#CartDrawer');
      var liveEl = document.querySelector('#CartDrawer');
      if (!newEl || !liveEl) return false;
      liveEl.innerHTML = newEl.innerHTML;
      return true;
    } catch (e) { return false; }
  }

  function swapCartBubble(sectionsPayload) {
    var html = sectionsPayload['cart-icon-bubble'];
    if (!html) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newEl = doc.querySelector('.shopify-section');
      var liveEl = document.getElementById('cart-icon-bubble');
      if (newEl && liveEl) liveEl.innerHTML = newEl.innerHTML;
    } catch (e) { /* ignore */ }
  }

  function notifyCartUpdate() {
    try {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-collection-upsell' });
      }
    } catch (e) { /* ignore */ }
  }

  // ── Close all open pickers ────────────────────────────────────────────────
  function closeAllPickers(except) {
    document.querySelectorAll('.ccu-picker.is-open').forEach(function (p) {
      if (p !== except) {
        p.classList.remove('is-open');
        var t = p.querySelector('[data-ccu-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ── Custom variant picker — toggle open / close ──────────────────────────
  document.body.addEventListener('click', function (event) {
    // Close on outside click
    if (!event.target.closest('.ccu-picker')) {
      closeAllPickers(null);
      return;
    }

    // Trigger click — toggle
    var trigger = event.target.closest('[data-ccu-trigger]');
    if (trigger) {
      var picker = trigger.closest('.ccu-picker');
      var isOpen = picker.classList.contains('is-open');
      closeAllPickers(null);
      if (!isOpen) {
        picker.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // Option click — select variant
    var option = event.target.closest('[data-ccu-option]');
    if (option) {
      var picker = option.closest('.ccu-picker');
      var item = option.closest('.ccu-item');
      var variantId = option.dataset.variantId;
      var price = option.dataset.price;
      var compare = option.dataset.compare;
      var available = option.dataset.available === 'true';
      var label = option.dataset.label;

      // Mark selected
      picker.querySelectorAll('[data-ccu-option]').forEach(function (o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-selected', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-selected', 'true');

      // Update trigger label
      var triggerLabel = picker.querySelector('.ccu-picker__label');
      if (triggerLabel) triggerLabel.textContent = label;

      // Close picker
      picker.classList.remove('is-open');
      picker.querySelector('[data-ccu-trigger]').setAttribute('aria-expanded', 'false');

      // Update add button
      var btn = item && item.querySelector('[data-ccu-add]');
      if (btn) {
        btn.dataset.variantId = variantId;
        btn.disabled = !available;
        btn.setAttribute('aria-disabled', available ? 'false' : 'true');
        var btnLabel = btn.querySelector('.ccu-item__btn-label');
        if (btnLabel && !available) {
          btnLabel.textContent = option.querySelector('.ccu-picker__oos')
            ? option.querySelector('.ccu-picker__oos').textContent.replace(' — ', '')
            : btnLabel.textContent;
        }
      }

      // Update prices
      var priceEl = item && item.querySelector('.ccu-item__price');
      var compareEl = item && item.querySelector('.ccu-item__compare');
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (compareEl) {
        var showCompare = compare && parseInt(compare, 10) > parseInt(price, 10);
        compareEl.textContent = showCompare ? formatMoney(compare) : '';
        compareEl.style.display = showCompare ? '' : 'none';
      }
      return;
    }
  });

  // Keyboard support: Enter/Space on option, Escape to close
  document.body.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllPickers(null);
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      var option = event.target.closest('[data-ccu-option]');
      if (option) { event.preventDefault(); option.click(); }
    }
  });

  // ── Add-to-cart handler ───────────────────────────────────────────────────
  document.body.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ccu-add]');
    if (!btn) return;
    if (btn.dataset.ccuLoading === '1') return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    event.preventDefault();
    setLoading(btn, true);

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    var cartAddUrl = (window.Shopify && window.Shopify.routes)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          console.warn('[CCU] Add error:', data.description);
          setLoading(btn, false);
          return;
        }
        if (data.sections) {
          swapCartDrawer(data.sections);
          swapCartBubble(data.sections);
        }
        notifyCartUpdate();
      })
      .catch(function (err) {
        console.error('[CCU] fetch error:', err);
        setLoading(btn, false);
      });
  });

})();
